// The short black confirmation after a write — "Now at FL - Plumbing",
// "QA32731 → Closed". It reports something already true on screen and goes
// away on its own, so nothing is ever only said here.

import { useEffect } from 'react';
import { useStore } from '@/store';

const TOAST_MS = 2600;

export function Toast() {
  const toast = useStore((s) => s.toast);
  const clear = useStore((s) => s.clearToast);
  useEffect(() => {
    if (!toast) return;
    const id = setTimeout(clear, TOAST_MS);
    return () => clearTimeout(id);
  }, [toast, clear]);
  if (!toast) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'absolute',
        left: '50%',
        bottom: 88,
        transform: 'translateX(-50%)',
        background: 'var(--ink)',
        color: 'var(--bg)',
        borderRadius: 12,
        padding: '10px 16px',
        font: '600 12.5px Manrope,sans-serif',
        zIndex: 30,
        boxShadow: '0 10px 26px rgba(0,0,0,.25)',
        maxWidth: '90%',
        animation: 'ipRise .2s ease-out',
      }}
    >
      {toast.msg}
    </div>
  );
}
